import { defineComponent as _defineComponent } from 'vue'
import {
  NavBar,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary,
  Heading
} from '@warrenbrasil/nebraska-web';
import { ref } from 'vue';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import {
  PortfolioReviewData,
  PortfolioReviewRow
} from '@/modules/wealth/services/portfolio';
import { IDynamicContent } from '@/modules/common/types';
import { DynamicContentModal } from '@/modules/common/components/DynamicContentModal';

interface Props {
  portfolioReviewData: PortfolioReviewData;
  loading: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'submit'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTransactionDetails',
  props: {
    portfolioReviewData: null,
    loading: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(__props: any) {

const props = __props as {
  portfolioReviewData: PortfolioReviewData;
  loading: boolean;
}





const modalTitle = ref('');
const modalInfo = ref<IDynamicContent[]>([]);
const showCostsButton = ref(false);
const isDetailModalOpen = ref(false);

const toggleDetailModal = (row: PortfolioReviewRow) => {
  if (row) {
    modalTitle.value = row.label;
    modalInfo.value = row.content || [];
    showCostsButton.value = !!row.action;
  }
  isDetailModalOpen.value = !isDetailModalOpen.value;
};

return { __sfc: true,props, modalTitle, modalInfo, showCostsButton, isDetailModalOpen, toggleDetailModal, NavBar, ContentDisplay, ListDisplay, HeadingDisplay, ButtonContainer, ButtonPrimary, Heading, BackButton, DynamicContentModal }
}

})